export default __webpack_public_path__ + "static/media/logokeywhite.0e9bc090.svg";